export default "__VITE_ASSET__Cuc_$1_O__"